import React, { useState, useEffect } from 'react';
import axios from 'axios'; // FIXED: Uses global config from index.js
import FamilyTree from '../components/FamilyTree';

function AboutPage() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        // FIXED: Relative path uses the Cloud URL automatically
        const response = await axios.get('/api/family-members');
        setMembers(response.data);
      } catch (error) {
        console.error("Failed to fetch members:", error);
      }
    };
    fetchMembers();
  }, []);

  return (
    <div>
      <h1>About Our Family</h1>
      <p>Information about the family history will go here.</p>
      <div style={{marginTop: '2rem'}}>
        <h2>Family Tree</h2>
        {/* Pass empty handlers if this is just a view-only tree */}
        <FamilyTree members={members} onEditClick={() => {}} onDelete={() => {}} />
      </div>
    </div>
  );
}

export default AboutPage;